module.exports = __webpack_public_path__ + "img/wlv_21.15e348f8.png";